// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp_acc_mapping.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { StcsFstmtEnum, stcsFstmtEnumFromJSON, stcsFstmtEnumToJSON } from "./stcs_enums.entity";
import { StcsI18nLabelMap } from "./stcs_i18n.entity";

export const protobufPackage = "stcs_cmw";

export enum AcmLevel3CreditDebitEnum {
  ACM_LEVEL_3_CD_UNSPECIFIED = 0,
  /** ACM_LEVEL_3_CREDIT - Negative BS side */
  ACM_LEVEL_3_CREDIT = 1,
  /** ACM_LEVEL_3_DEBIT - Positive BS side */
  ACM_LEVEL_3_DEBIT = 2,
  ACM_LEVEL_3_CREDIT_AND_DEBIT = 3,
  UNRECOGNIZED = -1,
}

export function acmLevel3CreditDebitEnumFromJSON(object: any): AcmLevel3CreditDebitEnum {
  switch (object) {
    case 0:
    case "ACM_LEVEL_3_CD_UNSPECIFIED":
      return AcmLevel3CreditDebitEnum.ACM_LEVEL_3_CD_UNSPECIFIED;
    case 1:
    case "ACM_LEVEL_3_CREDIT":
      return AcmLevel3CreditDebitEnum.ACM_LEVEL_3_CREDIT;
    case 2:
    case "ACM_LEVEL_3_DEBIT":
      return AcmLevel3CreditDebitEnum.ACM_LEVEL_3_DEBIT;
    case 3:
    case "ACM_LEVEL_3_CREDIT_AND_DEBIT":
      return AcmLevel3CreditDebitEnum.ACM_LEVEL_3_CREDIT_AND_DEBIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AcmLevel3CreditDebitEnum.UNRECOGNIZED;
  }
}

export function acmLevel3CreditDebitEnumToJSON(object: AcmLevel3CreditDebitEnum): string {
  switch (object) {
    case AcmLevel3CreditDebitEnum.ACM_LEVEL_3_CD_UNSPECIFIED:
      return "ACM_LEVEL_3_CD_UNSPECIFIED";
    case AcmLevel3CreditDebitEnum.ACM_LEVEL_3_CREDIT:
      return "ACM_LEVEL_3_CREDIT";
    case AcmLevel3CreditDebitEnum.ACM_LEVEL_3_DEBIT:
      return "ACM_LEVEL_3_DEBIT";
    case AcmLevel3CreditDebitEnum.ACM_LEVEL_3_CREDIT_AND_DEBIT:
      return "ACM_LEVEL_3_CREDIT_AND_DEBIT";
    case AcmLevel3CreditDebitEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface StcsCompAccMapping {
  id: string;
  version: string;
  meta: StcsCompAccMappingMeta | undefined;
  pnl: StcsCompAccMappingFstmt | undefined;
  bs: StcsCompAccMappingFstmt | undefined;
  acm_std_acc_map: { [key: string]: AcmStdAccItem };
  i18n_custom_key: string;
  i18n_map: { [key: string]: StcsI18nLabelMap };
  is_draft: boolean;
}

export interface StcsCompAccMapping_AcmStdAccMapEntry {
  key: string;
  value: AcmStdAccItem | undefined;
}

export interface StcsCompAccMapping_I18nMapEntry {
  key: string;
  value: StcsI18nLabelMap | undefined;
}

export interface StcsCompAccMappingMeta {
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  ref_id_org: string;
  ref_id_comp: string;
  ref_id_user: string;
  version_name: string;
}

export interface StcsCompAccMappingFstmt {
  acm_map_level_2: { [key: string]: StcsCompAccMappingL2 };
}

export interface StcsCompAccMappingFstmt_AcmMapLevel2Entry {
  key: string;
  value: StcsCompAccMappingL2 | undefined;
}

export interface StcsCompAccMappingL2 {
  acm_map_level_3: { [key: string]: StcsCompAccMappingLevel3 };
}

export interface StcsCompAccMappingL2_AcmMapLevel3Entry {
  key: string;
  value: StcsCompAccMappingLevel3 | undefined;
}

export interface StcsCompAccMappingLevel3 {
  acc_item_fstmt: StcsFstmtEnum;
  level_3_credit_debit: AcmLevel3CreditDebitEnum;
  level_3_id: string;
  level_2_id: string;
  is_inter_comp: boolean;
  net_debt: boolean;
}

export interface AcmStdAccItem {
  acc_item_fstmt: StcsFstmtEnum;
  level_1_positive_id: string;
  level_1_negative_id: string;
  level_2_positive_id: string;
  level_2_negative_id: string;
  level_3_id: string;
  is_inter_comp: boolean;
  net_debt: boolean;
}

function createBaseStcsCompAccMapping(): StcsCompAccMapping {
  return {
    id: "",
    version: "",
    meta: undefined,
    pnl: undefined,
    bs: undefined,
    acm_std_acc_map: {},
    i18n_custom_key: "",
    i18n_map: {},
    is_draft: false,
  };
}

export const StcsCompAccMapping: MessageFns<StcsCompAccMapping> = {
  encode(message: StcsCompAccMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsCompAccMappingMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    if (message.pnl !== undefined) {
      StcsCompAccMappingFstmt.encode(message.pnl, writer.uint32(34).fork()).join();
    }
    if (message.bs !== undefined) {
      StcsCompAccMappingFstmt.encode(message.bs, writer.uint32(42).fork()).join();
    }
    Object.entries(message.acm_std_acc_map).forEach(([key, value]) => {
      StcsCompAccMapping_AcmStdAccMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    if (message.i18n_custom_key !== "") {
      writer.uint32(66).string(message.i18n_custom_key);
    }
    Object.entries(message.i18n_map).forEach(([key, value]) => {
      StcsCompAccMapping_I18nMapEntry.encode({ key: key as any, value }, writer.uint32(74).fork()).join();
    });
    if (message.is_draft !== false) {
      writer.uint32(80).bool(message.is_draft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompAccMappingMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pnl = StcsCompAccMappingFstmt.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.bs = StcsCompAccMappingFstmt.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = StcsCompAccMapping_AcmStdAccMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.acm_std_acc_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.i18n_custom_key = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          const entry9 = StcsCompAccMapping_I18nMapEntry.decode(reader, reader.uint32());
          if (entry9.value !== undefined) {
            message.i18n_map[entry9.key] = entry9.value;
          }
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.is_draft = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMapping {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsCompAccMappingMeta.fromJSON(object.meta) : undefined,
      pnl: isSet(object.pnl) ? StcsCompAccMappingFstmt.fromJSON(object.pnl) : undefined,
      bs: isSet(object.bs) ? StcsCompAccMappingFstmt.fromJSON(object.bs) : undefined,
      acm_std_acc_map: isObject(object.acm_std_acc_map)
        ? Object.entries(object.acm_std_acc_map).reduce<{ [key: string]: AcmStdAccItem }>((acc, [key, value]) => {
          acc[key] = AcmStdAccItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      i18n_custom_key: isSet(object.i18n_custom_key) ? globalThis.String(object.i18n_custom_key) : "",
      i18n_map: isObject(object.i18n_map)
        ? Object.entries(object.i18n_map).reduce<{ [key: string]: StcsI18nLabelMap }>((acc, [key, value]) => {
          acc[key] = StcsI18nLabelMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      is_draft: isSet(object.is_draft) ? globalThis.Boolean(object.is_draft) : false,
    };
  },

  toJSON(message: StcsCompAccMapping): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompAccMappingMeta.toJSON(message.meta);
    }
    if (message.pnl !== undefined) {
      obj.pnl = StcsCompAccMappingFstmt.toJSON(message.pnl);
    }
    if (message.bs !== undefined) {
      obj.bs = StcsCompAccMappingFstmt.toJSON(message.bs);
    }
    if (message.acm_std_acc_map) {
      const entries = Object.entries(message.acm_std_acc_map);
      if (entries.length > 0) {
        obj.acm_std_acc_map = {};
        entries.forEach(([k, v]) => {
          obj.acm_std_acc_map[k] = AcmStdAccItem.toJSON(v);
        });
      }
    }
    if (message.i18n_custom_key !== "") {
      obj.i18n_custom_key = message.i18n_custom_key;
    }
    if (message.i18n_map) {
      const entries = Object.entries(message.i18n_map);
      if (entries.length > 0) {
        obj.i18n_map = {};
        entries.forEach(([k, v]) => {
          obj.i18n_map[k] = StcsI18nLabelMap.toJSON(v);
        });
      }
    }
    if (message.is_draft !== false) {
      obj.is_draft = message.is_draft;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMapping>, I>>(base?: I): StcsCompAccMapping {
    return StcsCompAccMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMapping>, I>>(object: I): StcsCompAccMapping {
    const message = createBaseStcsCompAccMapping();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompAccMappingMeta.fromPartial(object.meta)
      : undefined;
    message.pnl = (object.pnl !== undefined && object.pnl !== null)
      ? StcsCompAccMappingFstmt.fromPartial(object.pnl)
      : undefined;
    message.bs = (object.bs !== undefined && object.bs !== null)
      ? StcsCompAccMappingFstmt.fromPartial(object.bs)
      : undefined;
    message.acm_std_acc_map = Object.entries(object.acm_std_acc_map ?? {}).reduce<{ [key: string]: AcmStdAccItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = AcmStdAccItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.i18n_custom_key = object.i18n_custom_key ?? "";
    message.i18n_map = Object.entries(object.i18n_map ?? {}).reduce<{ [key: string]: StcsI18nLabelMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsI18nLabelMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.is_draft = object.is_draft ?? false;
    return message;
  },
};

function createBaseStcsCompAccMapping_AcmStdAccMapEntry(): StcsCompAccMapping_AcmStdAccMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompAccMapping_AcmStdAccMapEntry: MessageFns<StcsCompAccMapping_AcmStdAccMapEntry> = {
  encode(message: StcsCompAccMapping_AcmStdAccMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      AcmStdAccItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMapping_AcmStdAccMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMapping_AcmStdAccMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = AcmStdAccItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMapping_AcmStdAccMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? AcmStdAccItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompAccMapping_AcmStdAccMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = AcmStdAccItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMapping_AcmStdAccMapEntry>, I>>(
    base?: I,
  ): StcsCompAccMapping_AcmStdAccMapEntry {
    return StcsCompAccMapping_AcmStdAccMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMapping_AcmStdAccMapEntry>, I>>(
    object: I,
  ): StcsCompAccMapping_AcmStdAccMapEntry {
    const message = createBaseStcsCompAccMapping_AcmStdAccMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? AcmStdAccItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompAccMapping_I18nMapEntry(): StcsCompAccMapping_I18nMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompAccMapping_I18nMapEntry: MessageFns<StcsCompAccMapping_I18nMapEntry> = {
  encode(message: StcsCompAccMapping_I18nMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsI18nLabelMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMapping_I18nMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMapping_I18nMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsI18nLabelMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMapping_I18nMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsI18nLabelMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompAccMapping_I18nMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsI18nLabelMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMapping_I18nMapEntry>, I>>(base?: I): StcsCompAccMapping_I18nMapEntry {
    return StcsCompAccMapping_I18nMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMapping_I18nMapEntry>, I>>(
    object: I,
  ): StcsCompAccMapping_I18nMapEntry {
    const message = createBaseStcsCompAccMapping_I18nMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsI18nLabelMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompAccMappingMeta(): StcsCompAccMappingMeta {
  return {
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
    ref_id_org: "",
    ref_id_comp: "",
    ref_id_user: "",
    version_name: "",
  };
}

export const StcsCompAccMappingMeta: MessageFns<StcsCompAccMappingMeta> = {
  encode(message: StcsCompAccMappingMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(18).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(26).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(34).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(42).string(message.ref_id_comp);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(50).string(message.ref_id_user);
    }
    if (message.version_name !== "") {
      writer.uint32(58).string(message.version_name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMappingMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMappingMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.version_name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMappingMeta {
    return {
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      version_name: isSet(object.version_name) ? globalThis.String(object.version_name) : "",
    };
  },

  toJSON(message: StcsCompAccMappingMeta): unknown {
    const obj: any = {};
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.version_name !== "") {
      obj.version_name = message.version_name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMappingMeta>, I>>(base?: I): StcsCompAccMappingMeta {
    return StcsCompAccMappingMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMappingMeta>, I>>(object: I): StcsCompAccMappingMeta {
    const message = createBaseStcsCompAccMappingMeta();
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.version_name = object.version_name ?? "";
    return message;
  },
};

function createBaseStcsCompAccMappingFstmt(): StcsCompAccMappingFstmt {
  return { acm_map_level_2: {} };
}

export const StcsCompAccMappingFstmt: MessageFns<StcsCompAccMappingFstmt> = {
  encode(message: StcsCompAccMappingFstmt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.acm_map_level_2).forEach(([key, value]) => {
      StcsCompAccMappingFstmt_AcmMapLevel2Entry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMappingFstmt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMappingFstmt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsCompAccMappingFstmt_AcmMapLevel2Entry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.acm_map_level_2[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMappingFstmt {
    return {
      acm_map_level_2: isObject(object.acm_map_level_2)
        ? Object.entries(object.acm_map_level_2).reduce<{ [key: string]: StcsCompAccMappingL2 }>(
          (acc, [key, value]) => {
            acc[key] = StcsCompAccMappingL2.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: StcsCompAccMappingFstmt): unknown {
    const obj: any = {};
    if (message.acm_map_level_2) {
      const entries = Object.entries(message.acm_map_level_2);
      if (entries.length > 0) {
        obj.acm_map_level_2 = {};
        entries.forEach(([k, v]) => {
          obj.acm_map_level_2[k] = StcsCompAccMappingL2.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMappingFstmt>, I>>(base?: I): StcsCompAccMappingFstmt {
    return StcsCompAccMappingFstmt.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMappingFstmt>, I>>(object: I): StcsCompAccMappingFstmt {
    const message = createBaseStcsCompAccMappingFstmt();
    message.acm_map_level_2 = Object.entries(object.acm_map_level_2 ?? {}).reduce<
      { [key: string]: StcsCompAccMappingL2 }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = StcsCompAccMappingL2.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseStcsCompAccMappingFstmt_AcmMapLevel2Entry(): StcsCompAccMappingFstmt_AcmMapLevel2Entry {
  return { key: "", value: undefined };
}

export const StcsCompAccMappingFstmt_AcmMapLevel2Entry: MessageFns<StcsCompAccMappingFstmt_AcmMapLevel2Entry> = {
  encode(message: StcsCompAccMappingFstmt_AcmMapLevel2Entry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompAccMappingL2.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMappingFstmt_AcmMapLevel2Entry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMappingFstmt_AcmMapLevel2Entry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompAccMappingL2.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMappingFstmt_AcmMapLevel2Entry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompAccMappingL2.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompAccMappingFstmt_AcmMapLevel2Entry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompAccMappingL2.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMappingFstmt_AcmMapLevel2Entry>, I>>(
    base?: I,
  ): StcsCompAccMappingFstmt_AcmMapLevel2Entry {
    return StcsCompAccMappingFstmt_AcmMapLevel2Entry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMappingFstmt_AcmMapLevel2Entry>, I>>(
    object: I,
  ): StcsCompAccMappingFstmt_AcmMapLevel2Entry {
    const message = createBaseStcsCompAccMappingFstmt_AcmMapLevel2Entry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompAccMappingL2.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompAccMappingL2(): StcsCompAccMappingL2 {
  return { acm_map_level_3: {} };
}

export const StcsCompAccMappingL2: MessageFns<StcsCompAccMappingL2> = {
  encode(message: StcsCompAccMappingL2, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.acm_map_level_3).forEach(([key, value]) => {
      StcsCompAccMappingL2_AcmMapLevel3Entry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMappingL2 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMappingL2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsCompAccMappingL2_AcmMapLevel3Entry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.acm_map_level_3[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMappingL2 {
    return {
      acm_map_level_3: isObject(object.acm_map_level_3)
        ? Object.entries(object.acm_map_level_3).reduce<{ [key: string]: StcsCompAccMappingLevel3 }>(
          (acc, [key, value]) => {
            acc[key] = StcsCompAccMappingLevel3.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: StcsCompAccMappingL2): unknown {
    const obj: any = {};
    if (message.acm_map_level_3) {
      const entries = Object.entries(message.acm_map_level_3);
      if (entries.length > 0) {
        obj.acm_map_level_3 = {};
        entries.forEach(([k, v]) => {
          obj.acm_map_level_3[k] = StcsCompAccMappingLevel3.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMappingL2>, I>>(base?: I): StcsCompAccMappingL2 {
    return StcsCompAccMappingL2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMappingL2>, I>>(object: I): StcsCompAccMappingL2 {
    const message = createBaseStcsCompAccMappingL2();
    message.acm_map_level_3 = Object.entries(object.acm_map_level_3 ?? {}).reduce<
      { [key: string]: StcsCompAccMappingLevel3 }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = StcsCompAccMappingLevel3.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseStcsCompAccMappingL2_AcmMapLevel3Entry(): StcsCompAccMappingL2_AcmMapLevel3Entry {
  return { key: "", value: undefined };
}

export const StcsCompAccMappingL2_AcmMapLevel3Entry: MessageFns<StcsCompAccMappingL2_AcmMapLevel3Entry> = {
  encode(message: StcsCompAccMappingL2_AcmMapLevel3Entry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompAccMappingLevel3.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMappingL2_AcmMapLevel3Entry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMappingL2_AcmMapLevel3Entry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompAccMappingLevel3.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMappingL2_AcmMapLevel3Entry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompAccMappingLevel3.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompAccMappingL2_AcmMapLevel3Entry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompAccMappingLevel3.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMappingL2_AcmMapLevel3Entry>, I>>(
    base?: I,
  ): StcsCompAccMappingL2_AcmMapLevel3Entry {
    return StcsCompAccMappingL2_AcmMapLevel3Entry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMappingL2_AcmMapLevel3Entry>, I>>(
    object: I,
  ): StcsCompAccMappingL2_AcmMapLevel3Entry {
    const message = createBaseStcsCompAccMappingL2_AcmMapLevel3Entry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompAccMappingLevel3.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompAccMappingLevel3(): StcsCompAccMappingLevel3 {
  return {
    acc_item_fstmt: 0,
    level_3_credit_debit: 0,
    level_3_id: "",
    level_2_id: "",
    is_inter_comp: false,
    net_debt: false,
  };
}

export const StcsCompAccMappingLevel3: MessageFns<StcsCompAccMappingLevel3> = {
  encode(message: StcsCompAccMappingLevel3, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.acc_item_fstmt !== 0) {
      writer.uint32(8).int32(message.acc_item_fstmt);
    }
    if (message.level_3_credit_debit !== 0) {
      writer.uint32(16).int32(message.level_3_credit_debit);
    }
    if (message.level_3_id !== "") {
      writer.uint32(26).string(message.level_3_id);
    }
    if (message.level_2_id !== "") {
      writer.uint32(34).string(message.level_2_id);
    }
    if (message.is_inter_comp !== false) {
      writer.uint32(40).bool(message.is_inter_comp);
    }
    if (message.net_debt !== false) {
      writer.uint32(48).bool(message.net_debt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccMappingLevel3 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccMappingLevel3();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.acc_item_fstmt = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.level_3_credit_debit = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.level_3_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.level_2_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.is_inter_comp = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.net_debt = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccMappingLevel3 {
    return {
      acc_item_fstmt: isSet(object.acc_item_fstmt) ? stcsFstmtEnumFromJSON(object.acc_item_fstmt) : 0,
      level_3_credit_debit: isSet(object.level_3_credit_debit)
        ? acmLevel3CreditDebitEnumFromJSON(object.level_3_credit_debit)
        : 0,
      level_3_id: isSet(object.level_3_id) ? globalThis.String(object.level_3_id) : "",
      level_2_id: isSet(object.level_2_id) ? globalThis.String(object.level_2_id) : "",
      is_inter_comp: isSet(object.is_inter_comp) ? globalThis.Boolean(object.is_inter_comp) : false,
      net_debt: isSet(object.net_debt) ? globalThis.Boolean(object.net_debt) : false,
    };
  },

  toJSON(message: StcsCompAccMappingLevel3): unknown {
    const obj: any = {};
    if (message.acc_item_fstmt !== 0) {
      obj.acc_item_fstmt = stcsFstmtEnumToJSON(message.acc_item_fstmt);
    }
    if (message.level_3_credit_debit !== 0) {
      obj.level_3_credit_debit = acmLevel3CreditDebitEnumToJSON(message.level_3_credit_debit);
    }
    if (message.level_3_id !== "") {
      obj.level_3_id = message.level_3_id;
    }
    if (message.level_2_id !== "") {
      obj.level_2_id = message.level_2_id;
    }
    if (message.is_inter_comp !== false) {
      obj.is_inter_comp = message.is_inter_comp;
    }
    if (message.net_debt !== false) {
      obj.net_debt = message.net_debt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccMappingLevel3>, I>>(base?: I): StcsCompAccMappingLevel3 {
    return StcsCompAccMappingLevel3.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccMappingLevel3>, I>>(object: I): StcsCompAccMappingLevel3 {
    const message = createBaseStcsCompAccMappingLevel3();
    message.acc_item_fstmt = object.acc_item_fstmt ?? 0;
    message.level_3_credit_debit = object.level_3_credit_debit ?? 0;
    message.level_3_id = object.level_3_id ?? "";
    message.level_2_id = object.level_2_id ?? "";
    message.is_inter_comp = object.is_inter_comp ?? false;
    message.net_debt = object.net_debt ?? false;
    return message;
  },
};

function createBaseAcmStdAccItem(): AcmStdAccItem {
  return {
    acc_item_fstmt: 0,
    level_1_positive_id: "",
    level_1_negative_id: "",
    level_2_positive_id: "",
    level_2_negative_id: "",
    level_3_id: "",
    is_inter_comp: false,
    net_debt: false,
  };
}

export const AcmStdAccItem: MessageFns<AcmStdAccItem> = {
  encode(message: AcmStdAccItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.acc_item_fstmt !== 0) {
      writer.uint32(24).int32(message.acc_item_fstmt);
    }
    if (message.level_1_positive_id !== "") {
      writer.uint32(50).string(message.level_1_positive_id);
    }
    if (message.level_1_negative_id !== "") {
      writer.uint32(58).string(message.level_1_negative_id);
    }
    if (message.level_2_positive_id !== "") {
      writer.uint32(66).string(message.level_2_positive_id);
    }
    if (message.level_2_negative_id !== "") {
      writer.uint32(74).string(message.level_2_negative_id);
    }
    if (message.level_3_id !== "") {
      writer.uint32(82).string(message.level_3_id);
    }
    if (message.is_inter_comp !== false) {
      writer.uint32(112).bool(message.is_inter_comp);
    }
    if (message.net_debt !== false) {
      writer.uint32(120).bool(message.net_debt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AcmStdAccItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcmStdAccItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.acc_item_fstmt = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.level_1_positive_id = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.level_1_negative_id = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.level_2_positive_id = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.level_2_negative_id = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.level_3_id = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.is_inter_comp = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.net_debt = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AcmStdAccItem {
    return {
      acc_item_fstmt: isSet(object.acc_item_fstmt) ? stcsFstmtEnumFromJSON(object.acc_item_fstmt) : 0,
      level_1_positive_id: isSet(object.level_1_positive_id) ? globalThis.String(object.level_1_positive_id) : "",
      level_1_negative_id: isSet(object.level_1_negative_id) ? globalThis.String(object.level_1_negative_id) : "",
      level_2_positive_id: isSet(object.level_2_positive_id) ? globalThis.String(object.level_2_positive_id) : "",
      level_2_negative_id: isSet(object.level_2_negative_id) ? globalThis.String(object.level_2_negative_id) : "",
      level_3_id: isSet(object.level_3_id) ? globalThis.String(object.level_3_id) : "",
      is_inter_comp: isSet(object.is_inter_comp) ? globalThis.Boolean(object.is_inter_comp) : false,
      net_debt: isSet(object.net_debt) ? globalThis.Boolean(object.net_debt) : false,
    };
  },

  toJSON(message: AcmStdAccItem): unknown {
    const obj: any = {};
    if (message.acc_item_fstmt !== 0) {
      obj.acc_item_fstmt = stcsFstmtEnumToJSON(message.acc_item_fstmt);
    }
    if (message.level_1_positive_id !== "") {
      obj.level_1_positive_id = message.level_1_positive_id;
    }
    if (message.level_1_negative_id !== "") {
      obj.level_1_negative_id = message.level_1_negative_id;
    }
    if (message.level_2_positive_id !== "") {
      obj.level_2_positive_id = message.level_2_positive_id;
    }
    if (message.level_2_negative_id !== "") {
      obj.level_2_negative_id = message.level_2_negative_id;
    }
    if (message.level_3_id !== "") {
      obj.level_3_id = message.level_3_id;
    }
    if (message.is_inter_comp !== false) {
      obj.is_inter_comp = message.is_inter_comp;
    }
    if (message.net_debt !== false) {
      obj.net_debt = message.net_debt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AcmStdAccItem>, I>>(base?: I): AcmStdAccItem {
    return AcmStdAccItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AcmStdAccItem>, I>>(object: I): AcmStdAccItem {
    const message = createBaseAcmStdAccItem();
    message.acc_item_fstmt = object.acc_item_fstmt ?? 0;
    message.level_1_positive_id = object.level_1_positive_id ?? "";
    message.level_1_negative_id = object.level_1_negative_id ?? "";
    message.level_2_positive_id = object.level_2_positive_id ?? "";
    message.level_2_negative_id = object.level_2_negative_id ?? "";
    message.level_3_id = object.level_3_id ?? "";
    message.is_inter_comp = object.is_inter_comp ?? false;
    message.net_debt = object.net_debt ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
